import { render } from "./Section3.vue?vue&type=template&id=82d2bf70&scoped=true"
import script from "./Section3.vue?vue&type=script&lang=js"
export * from "./Section3.vue?vue&type=script&lang=js"

import "./Section3.vue?vue&type=style&index=0&id=82d2bf70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82d2bf70"]])

export default __exports__